import Input from "../components/Input";

const AddressIntlFields = ({ city, zip, country, handleUpdate, errors }) => {
	return (
		<div className="form-group three">
			<Input
				name="city"
				label="City"
				reqd={true}
				value={city || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>

			<Input
				name="zip"
				label="Postal Code"
				reqd={true}
				value={zip || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>

			<Input
				name="country"
				label="Country Code (2-letter)"
				reqd={true}
				value={country || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
		</div>
	);
};

export default AddressIntlFields;
